// src/index.js (根據你提供的版本修改)

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// [刪除] 我哋已經唔再用 Leaflet，所以可以刪除呢行 CSS
// import 'leaflet/dist/leaflet.css';

// [新增] 引入我哋嘅 MapProvider，佢會負責統一載入 Google Maps
import { MapProvider } from './context/MapProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // 你原本嘅註解：在開發中，StrictMode 會導致 useEffect 執行兩次，
  // 為了簡化 GPS 定位和 API 請求的行為，暫時移除它。
  // <React.StrictMode>

    // [新增] 用 MapProvider 包住整個 App
    // 咁樣做可以確保你整個 App（包括所有頁面）都可以共享同一個 Google Maps 載入狀態
    <MapProvider>
      <App />
    </MapProvider>
    
  // </React.StrictMode>
);